import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

interface FavoriteIcon {
  isFavorite?: boolean;
  size?: number;
  color?: string;
}

const styles = {
  favorite: css`
    color: ${colors.orange800} !important;
    cursor: pointer;
  `,
  default: css`
    cursor: pointer;
  `,
};

export const FavoriteIcon: React.FC<FavoriteIcon> = ({
  isFavorite = true,
  size = 30,
  color = colors.prussian,
}) =>
  isFavorite ? (
    <StarIcon sx={{ fontSize: pxToRem(size) }} className={styles.favorite} />
  ) : (
    <StarOutlineOutlinedIcon sx={{ fontSize: pxToRem(size), color }} className={styles.default} />
  );
